import http from '@/api/http';
import type { ShippingDirection } from '@/contexts/DirectionContext';
import type { SearchResponse } from '../interfaces/search.interface';

export const searchApi = {
  /**
   * Lansează un search global. `q` poate fi gol → backend-ul returnează
   * sugestii (pagini + entități recente).
   */
  async search(
    q: string,
    lang: string,
    companyId?: number,
    direction?: ShippingDirection,
  ): Promise<SearchResponse> {
    const params: Record<string, string | number> = { lang };
    if (q) params.q = q;
    if (typeof companyId === 'number') params.companyId = companyId;
    if (direction) params.direction = direction;
    const response = await http.get('/search', { params });
    return (
      (response.data?.data as SearchResponse) ?? { results: [], total: 0 }
    );
  },
};
